<div class="card border-0 m-0 p-1">
  <div class="flex mb-2 gap-2 justify-content-end">
    <p-button
      (onClick)="active = 0"
      rounded="true"
      styleClass="w-2rem h-2rem p-0"
      [outlined]="active !== 0"
      icon="pi pi-pencil"
      [disabled]="isDisabled"
    />
    <p-button
      (onClick)="active = 1"
      rounded="true"
      styleClass="w-2rem h-2rem p-0"
      [outlined]="active !== 1"
      [disabled]="isDisabled2"
      icon="pi pi-database"
    />
    <p-button
      (onClick)="active = 2"
      rounded="true"
      styleClass="w-2rem h-2rem p-0"
      [outlined]="active !== 2"
      [disabled]="isDisabled3"
      icon="pi pi-file-import"
    />
  </div>

  <p-tabView [(activeIndex)]="active">
    <!-- Paso 1: datos básicos del catálogo -->
    <p-tabPanel header="Paso 1" [disabled]="isDisabled">
      <form [formGroup]="form">
        <formly-form
          [form]="form"
          [fields]="fields"
          [model]="model"
        ></formly-form>
      </form>
      <div class="button-container">
        <p-button
          label="Crear"
          (onClick)="createCatalog()"
          [disabled]="form.invalid"
        ></p-button>
      </div>
    </p-tabPanel>

    <!-- Paso 2: credenciales de sincronización -->
    <p-tabPanel header="Paso 2" [disabled]="isDisabled2">
      <form [formGroup]="formSync">
        <formly-form
          [form]="formSync"
          [fields]="fieldsSync"
          [model]="modelSync"
        ></formly-form>
      </form>
      <div class="button-container">
        <p-button
          label="Test"
          (onClick)="checkConnection()"
          [disabled]="formSync.invalid"
        ></p-button>
        <p-button
          class="ml-2"
          label="Continuar"
          [disabled]="nextButtonDisabled"
          (onClick)="passNextStep()"
        ></p-button>
      </div>
      <div *ngIf="loading" class="progress-container">
        <p-progressBar
          mode="indeterminate"
          [style]="{ 'margin-top': '12px', height: '6px' }"
        />
      </div>
    </p-tabPanel>

    <!-- Paso 3: importación inicial -->
    <p-tabPanel header="Paso 3" [disabled]="isDisabled3">
      <div class="tab-content">
        <h3>Importar catálogo</h3>
        <p-table
          *ngIf="showTable"
          [value]="importData"
          [responsiveLayout]="'scroll'"
          class="p-mt-3"
          [style]="{ 'margin-bottom': '100px' }"
        >
          <ng-template pTemplate="header">
            <tr>
              <th>Descripción</th>
              <th>Cantidad</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData>
            <tr>
              <td>{{ rowData.label }}</td>
              <td>{{ rowData.value }}</td>
            </tr>
          </ng-template>
        </p-table>
        <div class="button-container">
          <p-button
            label="Importar"
            (onClick)="importCatalog()"
            [disabled]="disableImportButton"
          ></p-button>
          <p-button
            class="ml-2"
            severity="secondary"
            label="Ir al catálogo"
            icon="pi pi-arrow-right"
            iconPos="right"
            (onClick)="goToCatalog()"
            [disabled]="closeButton"
          ></p-button>
        </div>
        <div *ngIf="loadingTable" class="progress-container">
          <p-progressBar
            mode="indeterminate"
            [style]="{ 'margin-top': '12px', height: '6px' }"
          />
        </div>
      </div>
    </p-tabPanel>
  </p-tabView>

  <p-toast></p-toast>
</div>
